<script setup lang="ts">
import ToneSelect from "@/components/mobile/ToneSelect.vue";

const props = defineProps<{
  toneId: number;
}>();

const emit = defineEmits<{
  (e: "update:toneId", tone?: number): void;
}>();
</script>
<template>
  <div class="p-4 flex flex-col gap-4">
    <div>{{ $t("User.mate.toneType") }}</div>
    <div class="flex flex-col gap-2">
      <tone-select
        :model-value="toneId"
        @update:modelValue="emit('update:toneId', $event)"
      />
    </div>
  </div>
</template>
